import { getEndpointsForEnv } from "@oneapp/data";

/** Container name registered by the remote on `window` */
export const REMOTE_NAME = "assetRenderingService";

/** Remote entry filename appended to the base URL */
const REMOTE_ENTRY_FILENAME = "remoteEntry.js";

function getBaseUrl(env?: string): string {
  const endpoints = getEndpointsForEnv(env);
  const url = endpoints.assetRendering ?? "";
  return url.replace(/\/+$/, "");
}

export function getRemoteEntryUrl(env?: string): string {
  return `${getBaseUrl(env)}/${REMOTE_ENTRY_FILENAME}`;
}

/** Extract the origin (scheme + host) from the base URL */
export function getRemoteBaseUrl(env?: string): string {
  const base = getBaseUrl(env);
  const match = base.match(/^(https?:\/\/[^/]+)/);
  return match?.[1] ?? base;
}
